import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useQuery } from '@apollo/react-hooks';
import { useHistory, useParams } from 'react-router-dom';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { GET_CONTACT_TRANSACTIONS } from '../../graphql/queries';
import colors from '../../styles/colors';
import Container from '../../shared/Container';
import Section from '../../shared/Section';
import NoContent from '../../shared/NoContent';
import * as Price from '../../util/Price';
import * as Phone from '../../util/PhoneNumber';


const TableContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;
const Table = styled.table`
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  height: auto;
  width: 100%;
  background: ${colors.white};
  display: table;
  border-collapse: collapse;
`;

const TooltipStyles = createGlobalStyle`

.__react_component_tooltip{
      display: inline-block !important;
      max-width: 300px;
    }

`;

const CardHeader = styled.tr`
  font-size: 1.2rem;
  align-items: center;
  border-top: 1px solid ${colors.grey6};
  width: 100%;
  box-sizing: border-box;
  text-align: left !important;
`;

const HeaderText = styled.th`
  font-size: 1.2rem;
  color: ${colors.grey3};
  width: 33%;
  padding: 15px 20px;
  border-right: 1px solid ${colors.grey6};
  width: ${(props) => props.width || 'unset'};
  @media screen and (max-width: 350px) {
    padding: 15px 5px;
  }
`;

const RowText = styled.td`
  font-size: 1.4rem;
  color: ${colors.grey1};
  font-weight: 500;
  width: ${(props) => props.width || 'unset'};
  padding: 15px 20px;
  border-right: 1px solid ${colors.grey6};
  @media screen and (max-width: 350px) {
    padding: 15px 10px;
  }
`;

const BackButton = styled.div`
  cursor: pointer;
  z-index: 30;
  display: flex;
  position: absolute;
  right: 5%;
  top: 10px;
  @media screen and (max-width: 450px) {
    /* right: 0; */
  }
`;

const ToolbarItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;
  font-weight: 600;
  color: ${colors.seaGreen};
  font-size: 1.4rem;
  cursor: pointer;
  width: max-content;
  border-radius: 10px;
  padding: 8px 27px;
  background: rgba(26, 188, 156, 0.1);
  @media screen and (max-width: 991px) {
    ${(props) => props.headerDirection === 'column' && 'margin-top:10px'};
  }
  @media screen and (max-width: 767px) {
    padding: 2vw 6vw;
  }
`;

export default function CustomerTransactions() {
  const { phoneNumber } = useParams();
  const { data, loading } = useQuery(GET_CONTACT_TRANSACTIONS, {
    variables: {
      phoneNumber,
    },
  });

  const history = useHistory();

  return (
    <Container>
      <TooltipStyles />
      <BackButton
        data-tip="Back To Contacts List"
        onClick={() => history.push('/customers')}
      >
        <ToolbarItem>Back</ToolbarItem>
      </BackButton>
      <Section headerTitle="Customer Details" loading={loading}>
        <TableContainer>
          {data?.getContactTransactions?.length > 0 ? (
            <Table>
              <CardHeader>
                <HeaderText width="40%">DATE-TIME</HeaderText>
                <HeaderText width="40%">TYPE</HeaderText>
                <HeaderText width="20%">AMOUNT</HeaderText>
              </CardHeader>
              {data?.getContactTransactions?.map((transaction, index) => {
                const format = 'MM/DD/YYYY hh:mm A';
                const convertedDateTime = moment(
                  transaction.time * 1000,
                ).format(format);
                const amount = transaction.amount > 0
                  ? `$${Price.output(transaction.amount, true)}`
                  : '-';
                let name = '';
                if (transaction?.campaignName) {
                  name = transaction.campaignName;
                } else if (transaction?.refferrerPhoneNumber) {
                  name = Phone.formatPhoneNumber(transaction.refferrerPhoneNumber);
                }
                return (
                  <CardHeader key={index}>
                    <RowText width="40%">{convertedDateTime}</RowText>
                    <RowText width="40%">
                      {name
                        ? `${transaction.type} (${name})`
                        : transaction.type}
                    </RowText>
                    <RowText width="20%">{amount}</RowText>
                  </CardHeader>
                );
              })}
            </Table>
          ) : (
            <NoContent
              header="No Transactions"
              description="Currently this customer does'nt have any transactions."
            />
          )}
        </TableContainer>
        <ReactTooltip place="right" type="dark" effect="solid" />
      </Section>
    </Container>
  );
}
